export const FLAG_GETTING_DELAY_REASONS = 'FLAG_GETTING_DELAY_REASONS';
export const GET_DELAY_REASONS = 'GET_DELAY_REASONS';
export const CLEAR_DELAY_REASONS = 'CLEAR_DELAY_REASONS';
